import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import MenuItem from '@mui/material/MenuItem';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { getPartner, getPartnerGuid } from '../../../../../lib/access.es6';
import { buildBenefitsWithWarnings } from '../../utils/waitingPeriodHelpers';
import WaitingPeriodWarnings from './WaitingPeriodWarnings';
import { findExistingDeathClaim, isDeathBenefit } from '../../utils/deathClaimGate';
import { PARTNERS_WITH_SINGLE_DEATH_CLAIM } from '../../../../../routes/PartnersEnum';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


function getStyles(name, selectBenefit, theme) {
  return {
    fontWeight:
    selectBenefit.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}


const SelectMember = (props) => {
  if (!props.eventQuote) {
    return
  }

  const classes = useStyle();
  const theme = useTheme();
  const [selectMember, setSelectMember] = useState('');
  const [selectBenefit, setSelectBenefit] = useState([]);
  //const [benefitName, setBenefitName] = useState([]);
  const [waitingPeriodWarnings, setWaitingPeriodWarnings] = useState([]);

  const currencyCode = getPartner().country.currency_code;

  const handleChange = (event) => {
    const { name, value } = event.target

    if (name === "selectmember") {
      setSelectMember(value)
      setSelectBenefit([])
      setWaitingPeriodWarnings([])
      const tempClaimInitiation = props.claimInitiationPayload;
      tempClaimInitiation["benefits"] = []
      tempClaimInitiation["dependant_guid"] = value.dependant.guid
      tempClaimInitiation["member"] = value
      props.setClaimInitiationPayload(tempClaimInitiation);
      console.log("member details", value)
    }
    // if (name === "selectbenefit") {
    //   setSelectBenefit(value)
    //   handleMember(value)
    // }
  }


  const handleMember = (benefits) => {
    const tempClaimInitiation = props.claimInitiationPayload;
    tempClaimInitiation["benefits"] =
      benefits.map((benefit) => {return {
        type: benefit
      }} )
    console.log("temp claim init",{tempClaimInitiation})
    tempClaimInitiation["dependant_guid"] = selectMember.dependant.guid;
    tempClaimInitiation["member"] = selectMember

    // AccessBank only: Check waiting period for benefits
    if (getPartnerGuid() === 'accessbank') {
      const { warnings } = buildBenefitsWithWarnings(benefits, selectMember.benefits);
      console.log('warnings: ', warnings);
      
      setWaitingPeriodWarnings(warnings);
    }

    props.setClaimInitiationPayload(tempClaimInitiation);
  }


  const handleBenefitChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectBenefit(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
    handleMember(value)
  };
  const members = props.eventQuote.policy_schedule_entries ? props.eventQuote.policy_schedule_entries : []

  const singleDeathClaim = PARTNERS_WITH_SINGLE_DEATH_CLAIM.indexOf(getPartnerGuid()) !== -1
  const existingDeathClaim = singleDeathClaim && selectMember
    ? findExistingDeathClaim(
      props.customerClaimsDcp,
      props.eventQuote.policy_guid,
      selectMember.dependant.guid
    )
    : null
  const selectedDeathBenefit = singleDeathClaim
    ? selectBenefit.filter(isDeathBenefit)[0]
    : null
  const isBenefitBlocked = (type) => {
    if (!isDeathBenefit(type)) return false
    if (existingDeathClaim) return true
    return !!selectedDeathBenefit && selectedDeathBenefit !== type
  }

  return (
    <>
      <ValidatorForm
        onSubmit={() => { }}
      >
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12} md={6} sm={6}>
            <SelectValidator
              labelId="select-member"
              id="select-member"
              value={selectMember}
              name='selectmember'
              type="text"
              label="Select Member"
              onChange={handleChange}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please select a member']}
              style={{ width: "100%" }}
              sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
              }}
            >

              {
                members.map((entry, index) => (
                  <MenuItem
                    key={index}
                    sx={{
                      fontFamily: "Open Sans",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: "12px",
                      lineHeight: "16px",
                      letterSpacing: "0.005em",
                      color: "#000000",
                    }}
                    value={entry}>{entry.dependant.first_name + " " + entry.dependant.last_name}</MenuItem>
                ))
              }

            </SelectValidator>
          </Grid>
          <Grid item xs={12} md={6} sm={6}>

          <FormControl sx={{ m: 1, width: "100%" }}>
              <InputLabel id="demo-multiple-chip-label">Select Benefits</InputLabel>
              <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={selectBenefit}
                onChange={handleBenefitChange}
                input={<OutlinedInput id="select-multiple-chip" label="Select Benefits" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {

                (selectMember ? selectMember.benefits : []).map((benefit, index) => {
                  return <MenuItem
                    key={index}
                    style={getStyles(benefit, selectBenefit, theme)}
                    sx={{
                      fontFamily: "Open Sans",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: "10px",
                      lineHeight: "16px",
                      letterSpacing: "0.005em",
                      color: "#000000",
                    }}
                     value={benefit.type}
                     disabled={isBenefitBlocked(benefit.type)}
                     >
                      {benefit.type + "-" + (benefit.cover_amount_in_cents/100).toLocaleString()}
                      {existingDeathClaim && isDeathBenefit(benefit.type) ? " (already claimed)" : ""}
                      </MenuItem>

                })
                }
              </Select>
            </FormControl>
            {existingDeathClaim ? (
              <p style={{ color: '#b71c1c', fontSize: '12px', margin: '0 8px' }}>
                {'A death claim (' + existingDeathClaim.claim_number + ', ' +
                  existingDeathClaim.status + ') already exists for this ' +
                  'member, so no further death benefit can be claimed.'}
              </p>
            ) : null}
          </Grid>
        </Grid>

        <WaitingPeriodWarnings warnings={waitingPeriodWarnings} currencyCode={currencyCode} />
      </ValidatorForm>
    </>
  )
}

export default SelectMember
